import React from "react";
import { QuoteIcon } from "lucide-react";
import { useTestimonials, TestimonialProps } from "@/hooks/use-testimonials";
import { Skeleton } from "@/components/ui/skeleton";

const TestimonialCard = ({
  quote,
  name,
  location,
  image,
  delay,
}: TestimonialProps) => (
  <div
    className="rounded-xl p-6 md:p-8 glass-card border border-gray-200 animate-fade-in opacity-0"
    style={{ animationDelay: `${delay}s` }}
  >
    <QuoteIcon className="h-8 w-8 text-gold mb-4" />
    <p className="text-navy/80 mb-6 italic">{quote}</p>
    <div className="flex items-center">
      <div className="mr-4 h-12 w-12 rounded-full overflow-hidden">
        <img src={image} alt={name} className="h-full w-full object-cover" />
      </div>
      <div>
        <h4 className="font-bold text-navy">{name}</h4>
        <p className="text-sm text-navy/70">{location}</p>
      </div>
    </div>
  </div>
);

const TestimonialCardSkeleton = () => (
  <div className="rounded-xl p-6 md:p-8 border border-gray-200">
    <Skeleton className="h-8 w-8 mb-4" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-2/3 mb-6" />
    <div className="flex items-center">
      <Skeleton className="mr-4 h-12 w-12 rounded-full" />
      <div>
        <Skeleton className="h-4 w-24 mb-1" />
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const { testimonials, isLoading, error } = useTestimonials();

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 w-full max-w-full">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-navy">
            GlowHer Community
          </h2>
          <p className="mt-4 text-lg text-navy/70 max-w-2xl mx-auto">
            Join thousands of women who are transforming their lives with our
            expert guidance
          </p>
        </div>

        {error && (
          <div className="bg-red-100 text-red-700 p-4 mx-auto max-w-4xl mb-8 rounded-md text-center">
            {error}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {isLoading
            ? // Hiển thị skeleton loader khi đang tải
              [...Array(3)].map((_, index) => (
                <TestimonialCardSkeleton key={index} />
              ))
            : // Hiển thị testimonials khi đã tải xong
              testimonials.map((testimonial, index) => (
                <TestimonialCard key={index} {...testimonial} />
              ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
